import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    codeProp: 'bdNo',
    detailUrl: '/BdDetail',
    detailIdProp: 'bdId',
    listUrl: '/BdBoda2List',
    mapProp: 'bdMap',
    name: '程序模块',
    textProp: 'bdName',
    type: 'BD',
}
